import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="apply-discount"
export default class extends Controller {
  static targets = ["formField", 'displayField']

  static values = {
    name: String
  }

  connect() {
    if (this.nameValue != '') {
      this.formFieldTarget.classList.add('d-none')
      this.displayFieldTarget.classList.remove('d-none')
    }
  }
}
